import Vue from 'vue';

let modevts = {}, ebus = new Vue();
ebus.Add = (id, type, fn) => {
	!modevts[id] && (modevts[id] = {});
    !modevts[id][type] && (modevts[id][type] = fn)
};
ebus.Emit = (id, type, data) => {
	let tmpobj = modevts[id] || {};
	return tmpobj[type] ? tmpobj[type](data) : {}
};

export default ebus


// WEBPACK FOOTER //
// ./src/common/events.js